<template>
	<c-dialog ref="dialog" width="500" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="账号" required>
				<c-input name="user_name" maxlength="20" :disabled="editState" tip="登录凭证，全局唯一不允许重复，设置后不可修改"></c-input>
			</c-form-item>
			<c-form-item label="姓名" required>
				<c-input name="user_realname" maxlength="10" ></c-input>
			</c-form-item>
			<c-form-item label="手机号码">
				<c-input name="phone" maxlength="11" tip="全局唯一不允许重复"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	
	data() {
		return {
      editState: false,
      selectedRole:[],
			selectedDepartment:[],
			selectedIdentity:[],
			is_manage:false   //是否超级管理员（1：是，2：否）
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
      this.editState = false;
			this.$refs.form.clear();
      if (data) {
        this.editState = true;
        this.$refs.form.set(data);
      }
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑用户' : '创建用户'
			});
		},

		/*******搜索角色*****************/
		searchRole(keyword, resolve){
			this.request({
				url:'/system/native/options',
				data: {
					options_code:'ROLE'
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索部门*****************/
		searchDepartment(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DEPARTMENT',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索身份********/
		searchIdentity(keyword, resolve){
			this.request({
				url:'/system/native/options',
				data: {
					options_code:'IDENTITY'
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/manage/user/edit':'/manage/user/add',
				rule: {
					user_name: '请输账号',
					user_realname: '请输姓名'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					if (this._editState){//编辑
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else {//新增
						this.$confirm({
							message: res,
							buttonName: '知道了',
							cancelButton: false,
							resolve: () => {
							}
						});

					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>